module.exports = __webpack_public_path__ + "static/img/8.68e9835.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/8.png
// module id = UIlC
// module chunks = 0